import { createContext } from 'react';

// Portals inherit this context; denied controls never enter the DOM/focus order.
export const ActionAccessContext = createContext(null);